import React, { useEffect, useState } from "react";
import apiService from "services/apiService";
import ProfileDetails from "./ProfileDetails";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import appConfig from "services/apiConfig";

interface User {
    operator_name: string;
    operator_email: string;
  password: string;
  image: string;
}

export default function UpdateProfile() {
  const [user, setUser] = useState<User | null>(null);
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [isUpdating, setIsUpdating] = useState(false); // Add state to track the update process

  useEffect(() => {
    let userdetails:any=window.localStorage.getItem('userdetails')
    if(userdetails){
        userdetails=JSON.parse(userdetails)
        console.log('userdetails ',userdetails)
        apiService
      .get("operator/"+userdetails?.id)
      .then((res) => {
        const fullImageUrl = `${appConfig.getBaseUrl()}/profiles/${res.data.image}`;
        console.log('Operator Data : ',res.data)
        setUser({ ...res.data, image: fullImageUrl });
      })
      .catch((err) => {
        console.log(`profile err: ${err}`);
      });
    }
    
  }, []);

  const handleSubmit = async (updatedUser: User) => {
    setIsUpdating(true); // Set updating state to true when the process starts

    const formData = new FormData();
    formData.append("operator_name", updatedUser.operator_name);
    formData.append("operator_email", updatedUser.operator_email);
    formData.append("status", "active");
    if (selectedImage) {
      formData.append("image", selectedImage);
    }
    if (updatedUser.password) {
      formData.append("password", updatedUser.password);
    }

    try {
      const response = await apiService.put("/operators/profile", formData);
      const fullImageUrl = `${appConfig.getBaseUrl()}/profile/${response.data.image}`;
      setUser((prev) => ({ ...prev, ...updatedUser, image: fullImageUrl }));

      toast.success("Profile updated successfully!");
    } catch (error) {
      toast.error("Error updating profile");
      console.error("Error updating profile:", error);
    } finally {
      setIsUpdating(false); // Reset updating state when the process finishes
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedImage(file);
    }
  };

  return (
    <>
      {user && (
        <ProfileDetails
          user={user}
          onUpdate={handleSubmit}
          onImageChange={handleImageChange}
          selectedImage={selectedImage}
          isUpdating={isUpdating} // Pass isUpdating to ProfileDetails
        />
      )}
      <ToastContainer />
    </>
  );
}
